import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material";
// import User from "./components/user/user";
import { useEffect, useMemo, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Routes } from "./Routes";
import ErrorBoundary from "./components/ErrorBoundary";
import UniversalBackdropLoading from "./components/UniversalBackdropLoading";
import UniversalFloatingFeedback from "./components/UniversalFloatingFeedback";
import UserContext from "./components/UserContext";
import { getAllSettings, getUserPermissions } from "./services-old/me.service";
import { Global_CTX } from "./contexts/global-ctx";
import { dark_theme, light_theme, Palette_Mode } from "./utils/theme";
import { INITIAL_FEEDBACK } from "./utils/constants";

function App() {
    const [feedback, set_feedback] = useState(INITIAL_FEEDBACK)
    const [user, setUser] = useState(null);
    const [offline, setOffline] = useState(false);
    const [permissions, setPermissions] = useState([]);
    const [showNavbar, setShowNavbar] = useState(true);
    const [refetch_counter, set_refetch_counter] = useState(0)
    const [palette_mode, set_palette_mode] = useState(Palette_Mode.DARK);
    const [settings, setSettings] = useState({
        school_name: "Zama School",
        logo: `icon.png`,
    });
    const [backdropLoading, setBackdropLoading] = useState(false);

    const theme = useMemo(
        () => (palette_mode === Palette_Mode.DARK ? dark_theme : light_theme),
        [palette_mode]
    );

    useEffect(() => {
        localStorage.setItem("theme", palette_mode);
    }, [palette_mode]);


    const [store, setStore] = useState({});


    // These are all LMS related code.

    // useEffect(() => {
    //     const htmlElement = document.querySelector("html");
    //     const rootElement = document.querySelector("#root");

    //     htmlElement.style.backgroundColor = theme.palette.background.default;
    //     rootElement.style.backgroundColor = theme.palette.background.default;
    // }, [theme]);

    // useEffect(() => {
    //     if (user) getUserPermissions().then((perms) => setPermissions(perms));
    // }, [user]);

    // useEffect(() => {
    //     if (permissions)
    //         getAllSettings().then((allSettings) => {
    //             setSettings({ ...settings, ...allSettings });
    //         });
    // }, [permissions]);

    // useEffect(() => {
    //     if (navigator.serviceWorker) {
    //         // caches
    //         //     .delete("paths")
    //         //     .then(() => {
    //         navigator.serviceWorker
    //             .register("sw-cache-site.js")
    //             .then((reg) => {
    //                 console.log("Serive worker registered");
    //             })
    //             .catch((err) => {
    //                 console.log(`Service worker registration failed: ${err}`);
    //             });
    //         // })
    //         // .catch(() => {});
    //     }
    // }, []);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />

            <BrowserRouter>
                <Global_CTX.Provider value={
                    {
                        offline,
                        set_offline: setOffline,

                        permissions,
                        set_permissions: setPermissions,
                        palette_mode,
                        set_palette_mode,
                        feedback,
                        set_feedback,
                        refetch_counter, set_refetch_counter
                    }
                }>

                    <UserContext.Provider
                        value={{
                            user,
                            setUser,
                            permissions,
                            setPermissions,
                            settings,
                            mode: palette_mode,
                            setMode: set_palette_mode,
                            feedback,
                            setFeedback: set_feedback,
                            setShow: (value) =>
                                set_feedback({ ...feedback, show: value }),
                            backdropLoading: backdropLoading,
                            setBackdropLoading,
                            store,
                            setStore,
                            offline,
                            setOffline,
                            showNavbar,
                            setShowNavbar,
                        }}
                    >

                        <ErrorBoundary>
                            <Routes />
                            <UniversalFloatingFeedback />
                            <UniversalBackdropLoading text={backdropLoading.text} />
                        </ErrorBoundary>
                    </UserContext.Provider>
                </Global_CTX.Provider>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
